<template>
	<app tabbar>
		<div class="user-info">
			<div class="user flex-center" @click="navigateTo('/user_info')">
				<div class="icon"><img src="@/assets/image/user_icon.jpg"></div>
				<div v-if="userInfo.id" class="flex-grow">
					<p class="phone">{{private(userInfo.phone, 'phone')}}</p>
					<p class="text">欢迎登录数字保函系统</p>
				</div>
				<div v-else class="flex-grow">
					<p class="phone">点击登录</p>
				</div>
				<i class="tf tf-angle-right"></i>
			</div>
			<div v-if="userInfo.id" class="info">
				<p>{{private(userInfo.name)}}</p>
				<p>社会信用代码：{{private(userInfo.yyzzh)}}</p>
			</div>
		</div>
		
		<ul class="menu-list">
			<li v-for="(item, i) in menuList" :key="i" class="flex-center" @click="navigateTo(item.path)">
				<i class="icon tf" :class="item.icon"></i>
				<p class="flex-grow">{{item.name}}</p>
				<ins v-if="item.icon.includes('message') && messageTotal > 0" class="dot">{{messageTotal}}</ins>
				<i class="angle tf tf-angle-right"></i>
			</li>
		</ul>
		
		<ul v-if="RE == 'Alpha'" class="menu-list">
			<a v-for="(item, i) in roleList" :key="i" @click="changeRole(item.data)"><li class="flex-center">
				<p class="flex-grow">{{item.name}}</p>
				<i class="angle tf tf-angle-right"></i>
			</li></a>
		</ul>
		
		<c-button v-if="userInfo.id" class="logout" size="m" @click="logout">退出登录</c-button>
	</app>
</template>

<script>
	import {mapState, mapGetters} from 'vuex'
	import fun from '@/assets/script/function.js'
	
	export default {
		data() {
			return {
				RE: this.getRE(),
				menuList: [{
					icon: 'tf-menu-user',
					name: '账号信息',
					path: '/user_info'
				}, {
					icon: 'tf-menu-message',
					name: '消息中心',
					path: '/message'
				}, {
					icon: 'tf-menu-manual',
					name: '操作手册',
					path: '/manual'
				}],
				roleList: [{
					name: '招标代理',
					data: {
						user_id: 'dl0000000001'
					}
				}, {
					name: '企业角色',
					data: {
						user_id: 'qy0000000001'
					}
				}, {
					name: '监理角色',
					data: {
						user_id: 'jl0000000001'
					}
				}, {
					name: '保险公司',
					data: {
						user_id: 'bx0000000001'
					}
				}, {
					name: '协助理赔',
					data: {
						user_id: 'lp0000000001'
					}
				}]
			}
		},
		
		computed: {
			...mapState(['elder', 'userInfo', 'messageTotal']),
			...mapGetters(['private'])
		},
		
		mounted() {
			this.$store.dispatch('updateMessageTotal');
		},
		
		methods: {
			changeRole(data) {
				this.request({
					url: '/user/login',
					data,
					loading: true,
					success: data => {
						fun.setCookie('session_id', data.sessionId);
						this.$store.dispatch('updateUserInfo');
					}
				});
			},
			
			logout() {
				this.$confirm({
					text: '确定要退出登录吗？',
					resolve: () => {
						fun.removeCookie('session_id');
						this.$store.commit('setUserInfo', {});
						this.navigateTo('/login');
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.user-info {
		border-radius: .12rem;
		padding: 0 .32rem;
		margin: .24rem .32rem;
		color: #fff;
		background: #0366F1;
		box-shadow: 0 5px 20px 0 rgba(3,102,241,.3);
			
		elder({
			height: 3.8rem
		})
		
		.user {
			padding: .32rem 0;
			
			.icon {
				width: 1rem;
				height: 1rem;
				border-radius: 100%;
				margin-right: .22rem;
				overflow: hidden;
			}
			
			.phone {
				font-size: .34rem;
				font-weight: bold;
				
				elder({
					font-size: .46rem
				})
			}
			
			.text {
				margin-top: .1rem;
				font-size: .26rem;
				
				elder({
					margin-top: .14rem,
					font-size: .38rem
				})
			}
		}
		
		.info {
			padding: .32rem 0;
			line-height: .5rem;
			font-size: .28rem;
			text-align: center;
			
			elder({
				line-height: .54rem,
				font-size: .36rem
			})
		}
	}
	
	.menu-list {
		border-radius: .12rem;
		padding: .24rem .28rem;
		margin: .32rem;
		background: #fff;
		
		li {
			height: 1rem;
			
			elder({
				height: 1.2rem
			})
			
			&:nth-child(n+2) {
				border-top: 1px solid #E9E9E9;
			}
			
			.icon {
				width: .6rem;
				font-size: .32rem;
				
				elder({
					width: .8rem,
					font-size: .44rem
				})
			}
			
			p {
				font-size: .32rem;
				font-weight: bold;
				
				elder({
					font-size: .44rem
				})
			}
			
			ins {
				box-sizing: border-box;
				min-width: .32rem;
				height: .32rem;
				border-radius: .16rem;
				padding: 0 .08rem;
				margin-right: .2rem;
				line-height: .34rem;
				font-size: .24rem;
				text-align: center;
				color: #fff;
				background: #E63633;
			}
			
			.angle {
				color: #686B73;
			}
		}
	}
	
	.logout {
		width: 6.86rem;
		margin: 0 .32rem .32rem;
	}
</style>
